/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import React from "react";

/**
 * @description 決済方法選択のラジオボタンコンポーネント
 * スタイルは、以下のファイルに宣言されているものを移植する形で実装
 * spwn/legacy/packages/portal/src/styles/mixin/checked-layout-mixin.tsx
 */
export const RadioButton: React.FC<{
  id?: string;
  name: string;
  defaultChecked?: boolean;
  label: string;
  logo: string;
  onClick: () => void;
}> = ({ id, name, defaultChecked = false, label, logo, onClick }) => {
  return (
    <label
      css={css`
        position: relative;
        display: block;
        margin-bottom: 28px;
      `}
    >
      <InputRadio
        id={id}
        name={name}
        defaultChecked={defaultChecked}
        onClick={onClick}
      />

      <CheckboxIcon />

      <div
        className="checkbox_text"
        css={css`
          background-color: #fff;
          border: 2px solid #dcdbdc;
          transition: 0.3s;
          cursor: pointer;
        `}
      >
        <div
          css={css`
            display: flex;
            flex-direction: column;
            gap: 4px;
            width: 100%;
            padding: 16px 4% 16px 15%;
            @media screen and (min-width: 768px) {
              padding: 16px 20px 16px 67px;
            }
          `}
        >
          <p
            css={css`
              font-size: 18px;
              font-weight: 700;
              line-height: 1.5em;
            `}
          >
            {label}
          </p>
          <div>
            <img
              src={logo}
              alt="logo"
              css={css`
                width: auto;
                height: 22px;
              `}
            />
          </div>
        </div>
      </div>
    </label>
  );
};

const InputRadio: React.FC<{
  id?: string;
  name: string;
  defaultChecked?: boolean;
  onClick: () => void;
}> = ({ id, name, defaultChecked = false, onClick }) => {
  return (
    <input
      id={id}
      name={name}
      type="radio"
      defaultChecked={defaultChecked}
      onClick={onClick}
      css={css`
        display: none;
        &:checked ~ .checkbox_text {
          background-color: #f2fdfd;
          border: 2px solid #009a9a;
        }
        &:checked + .checkbox_icon div {
          opacity: 1;
        }
      `}
    />
  );
};

const CheckboxIcon: React.FC = () => {
  return (
    <div
      className="checkbox_icon"
      css={css`
        position: absolute;
        top: 50%;
        left: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #009a9a;
        transform: translateY(-50%);
        z-index: 10;
        @media screen and (min-width: 768px) {
          width: 25px;
          height: 25px;
        }
      `}
    >
      <div
        css={css`
          width: 14px;
          height: 14px;
          background: #009a9a;
          border-radius: 50%;
          opacity: 0;
          transition: 0.3s;
          @media screen and (min-width: 768px) {
            width: 19px;
            height: 19px;
          }
        `}
      />
    </div>
  );
};
